import { Component } from '@angular/core';

@Component({
  selector: 'app-frame',
  standalone: false,
  templateUrl: './frame.page.html',
  styleUrl: './frame.page.scss'
})
export class FramePage {
}
